import React, { useMemo } from 'react';
import Chart from "react-apexcharts";
import { numberWithSpaces } from '../../../../helpers/index';
import { useLingui } from '@lingui/react';
import { IGraphContentData } from '../../../../interfaces/types';
import { EStatisticsInterval } from '../../../../../reducers/data';
import { t } from '@lingui/macro';
 
const skGraph = require("apexcharts/dist/locales/sk")
const csGraph = require("apexcharts/dist/locales/cs")
const deGraph = require("apexcharts/dist/locales/de")
const enGraph = require("apexcharts/dist/locales/en")

interface IProps {
    graphData: IGraphContentData,
    isPercentage: boolean,
    interval?: EStatisticsInterval
}

const ColumnStackedGraph = ({graphData, isPercentage}: IProps) => {
    const lingui = useLingui()

    // Must be before any early return — Rules of Hooks.
    // Forces a full Chart remount whenever series or category structure changes,
    // preventing ApexCharts stacked-bar internal state from getting out of sync.
    const chartKey = useMemo(
        () => (graphData.series as any[]).map((s: any) => s?.name ?? '').join('|')
              + '|' + graphData.categories.join(','),
        [graphData.series, graphData.categories]
    )

    if (!graphData?.series?.length || !graphData?.categories?.length) {
        return null
    }

    return (
        <Chart
            key={chartKey}
            options={{
                chart: {
                    stacked: true,
                    animations: { enabled: false },
                    redrawOnParentResize: true,
                    redrawOnWindowResize: true,
                    toolbar: {
                        show: true,
                        tools: {
                            download: '<span><svg class="sico wh16"><use xlink:href="/assets/layout/icons.svg#s_save"></use></svg>'
                        }
                    },
                    locales: [skGraph, csGraph, enGraph, deGraph],
                    defaultLocale: lingui.i18n.locale
                },
                plotOptions: {
                    bar: {
                        horizontal: false,
                        columnWidth: '55%',
                    },
                },
                stroke: {
                    show: false
                },
                grid: {
                    strokeDashArray: 10,
                },
                xaxis: {
                    categories: graphData.categories
                },
                legend: {
                    show: true,
                    position: 'bottom'
                },
                dataLabels: {
                    enabled: false
                },
                fill: {
                    opacity: 1
                },
                tooltip: {
                    y: {
                        formatter: (val: number) =>
                            isPercentage ? val + '%' : numberWithSpaces(val)
                    }
                },
                yaxis: {
                    title: {
                        text: t`Počet návštevníkov`
                    },
                    labels: {
                        formatter: (val) =>
                            isPercentage ? val + '%' : numberWithSpaces(val)
                    },
                }
            }}
            series={graphData.series as any}
            type="bar"
            height={450}
        />
    )
};

export default ColumnStackedGraph